import { cn } from './types';

interface LoadingStateProps {
  message?: string;
  className?: string;
}

export function LoadingState({
  message = 'Loading…',
  className,
}: LoadingStateProps) {
  return (
    <div className={cn('ui-loading', className)} role="status" aria-live="polite">
      <div className="ui-loading__spinner" aria-hidden="true" />
      <p>{message}</p>
    </div>
  );
}
